"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var next_intl_1 = require("next-intl");
var swr_hooks_1 = require("@l2p/swr-hooks");
var Resend = function (_a) {
    var error = _a.error, setTmpResetToken = _a.setTmpResetToken, phone = _a.phone;
    var t = (0, next_intl_1.useTranslations)('phoneVerification');
    var _b = (0, react_1.useState)(180), count = _b[0], setCount = _b[1];
    var _c = (0, react_1.useState)(false), isSent = _c[0], setIsSent = _c[1];
    var forgotPassword = (0, swr_hooks_1.useForgotPassword)({
        successAction: function (data) {
            var _a;
            setTmpResetToken((_a = data === null || data === void 0 ? void 0 : data.data) === null || _a === void 0 ? void 0 : _a.tempToken);
        },
    }).forgotPassword;
    var sendVerificationCodeAgain = (0, react_1.useCallback)(function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            if (phone)
                forgotPassword({ login: "+".concat(phone) });
            setIsSent(true);
            return [2 /*return*/];
        });
    }); }, [setIsSent]);
    (0, react_1.useEffect)(function () {
        if (count > 0) {
            var timer_1 = setTimeout(function () { return setCount(count - 1); }, 1000);
            return function () { return clearTimeout(timer_1); };
        }
    }, [count]);
    if (error)
        return (react_1.default.createElement(react_1.default.Fragment, null, isSent ? (react_1.default.createElement("div", { className: "".concat(styles_module_scss_1.default.repeat, " ").concat(styles_module_scss_1.default.error) },
            react_1.default.createElement("div", null,
                react_1.default.createElement("span", null, t('theCodeIsIncorrect') + ' '),
                react_1.default.createElement("span", { className: styles_module_scss_1.default.sent }, t('successfullySent'))))) : (react_1.default.createElement("div", { className: "".concat(styles_module_scss_1.default.repeat, " ").concat(styles_module_scss_1.default.error) },
            react_1.default.createElement("div", null,
                react_1.default.createElement("span", null, t('theCodeIsIncorrect') + ' '),
                react_1.default.createElement("span", { className: styles_module_scss_1.default.send, onClick: sendVerificationCodeAgain }, t('send')))))));
    if (count === 0)
        return (react_1.default.createElement(react_1.default.Fragment, null, isSent ? (react_1.default.createElement("div", { className: "".concat(styles_module_scss_1.default.repeat), dangerouslySetInnerHTML: {
                __html: "<span>".concat(t('didNotReceiveResentIn'), " <span class=").concat(styles_module_scss_1.default.sent, ">").concat(t('successfullySent'), "</span></span>"),
            } })) : (react_1.default.createElement("div", { className: styles_module_scss_1.default.repeat },
            react_1.default.createElement("div", null,
                react_1.default.createElement("span", { dangerouslySetInnerHTML: {
                        __html: "".concat(t('didNotReceiveResentIn')),
                    } }),
                react_1.default.createElement("span", { className: styles_module_scss_1.default.send, onClick: sendVerificationCodeAgain }, t('send')))))));
    return (react_1.default.createElement("div", { className: styles_module_scss_1.default.repeat },
        react_1.default.createElement("div", null,
            react_1.default.createElement("span", { dangerouslySetInnerHTML: {
                    __html: t('didNotReceiveResentIn'),
                } }),
            react_1.default.createElement("span", { className: styles_module_scss_1.default.seconds }, "".concat(count, " ").concat(t('seconds')),
                " "))));
};
exports.default = Resend;
